import { fetchQualifiedResults } from '../utils/data-fetch/fetchQualifiedResults';
import type Lead from '../types/leadDelivery';

type Params = {
  lead: Lead;
  publisherToken?: string;
  trackingContext?: {
    anonymousId?: string;
  };
  degree?: string;
  category?: string;
  subject?: string;
  presentationUrl?: string;
  forceLinkoutSchoolIds?: number[];
  schoolIds?: number[];
  excludeProgramIds?: number[];
  limit?: number;
  exactOnly?: boolean;
  qualified?: string[];
  unqualified?: string[];
};

const getQualifiedResults = async (params: Params) => {
  const data = await fetchQualifiedResults(params);

  return {
    exactResults: data.exactResults,
    relatedResults: data.relatedResults,
    recommendedResults: data.recommendedResults,
    spotlightResults: data.spotlightResults,
    qualified: data.qualified?.map((item) => item.id) ?? [],
    unqualified: data.unqualified?.map((item) => item.id) ?? [],
    locationInference: data.locationInference,
  };
};

export default getQualifiedResults;
